// extracted by mini-css-extract-plugin
export default {"contactPersonItem":"contactPersonItem---jNlk8","contactPersonItemContent":"contactPersonItemContent---aGUOq"};